export default __webpack_public_path__ + "static/gdpr-72b2d314196b42706023471da72b1b16.png";